import React from 'react'
import { Stack } from '@jarvis/web-stratus-client'
import { Signup } from '../src'
import { OnboardingType, ShellProps, Properties } from '../src/types'
import projectNames from '../src/configs/projectNames'
import { SessionData } from '../src/lib/sessionData'
import { loadDevTools } from '../src/lib/loadDevTools'
import { useEffectOnce } from '../src/hooks'
import { setDyServerCookie } from '../src/lib/dynamicYieldHelper'
import '../src/styles/global.scss'

declare global {
  interface Window {
    Shell: ShellProps
  }
}

interface RootProps {
  stack: Stack
  properties: Properties
}

/**
 * @function Root Main function
 * @param props
 * @returns
 */
export default function Root({ stack, properties }: RootProps) {
  const { v1 } = window.Shell as ShellProps
  const {
    analytics,
    authProvider,
    navigation,
    store,
    localization,
    serviceRouting,
    sessionInterface,
    tenantHandlerInterface,
    userSession,
    app,
    theme
  } = v1

  const onboarding = store?.state?.onboarding
    ? { ...(store?.state?.onboarding as OnboardingType) }
    : { ...(new SessionData('onboardingStateData').get() as OnboardingType) }

  useEffectOnce(() => {
    setDyServerCookie()
  })

  loadDevTools(stack)

  // You can find the "stack" information by props
  // const stack = props.stack.
  return (
    <section
      className={`${projectNames.namespace}`}
      id={projectNames.packageJsonName}
    >
      <Signup
        stack={stack}
        properties={properties}
        onboarding={onboarding}
        analytics={analytics}
        authProvider={authProvider}
        navigation={navigation}
        localization={localization}
        serviceRouting={serviceRouting}
        sessionInterface={sessionInterface}
        tenantHandlerInterface={tenantHandlerInterface}
        userSession={userSession}
        app={app}
        theme={theme}
      />
    </section>
  )
}
